import React from "react";
import RenderOneQR from "./components/RenderOneQR";
import MultipleGeneratorLayout from "./components/common/MultipleGeneratorLayout";

const STORAGE_KEY = "multipleQRData";
const DEFAULT_DATA = ["https://phong.info", "QR 02", "", ""];
const MAX_ITEMS = 40;

const MultipleQR: React.FC = () => {
  return (
    <MultipleGeneratorLayout
      storageKey={STORAGE_KEY}
      defaultData={DEFAULT_DATA}
      maxItems={MAX_ITEMS}
      itemName="QR code"
      confirmClearMessage="Are you sure you want to clear all QR codes?"
      RenderComponent={RenderOneQR as any} // using 'as any' temporarily until RenderOneQR is converted to TS
    />
  );
};

export default MultipleQR;
